import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TenancyContext } from '@core/tenancy';
import { TenantKey } from '@app/core/enums/tenant-key.enum';

import { GuardianshipRouteSegmentsEnum } from '@app/guardianship/shared/enums/guardianship-routes-segments.enum';
import { GUARDIANSHIP_START_ROUTES_SEGMENTS } from '../shared/enums/guardianship-start-routes-segments.enum';

@Injectable({ providedIn: 'root' })
export class GuardianshipStartNavigationService {
  private readonly _tenancy = inject(TenancyContext);
  private readonly _router = inject(Router);

  public goToCourtOrder() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.GUARDIANSHIP,
        GuardianshipRouteSegmentsEnum.Start,
        GUARDIANSHIP_START_ROUTES_SEGMENTS.courtOrder,
      ),
    ]);
  }

  public goToAccount() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.GUARDIANSHIP,
        GuardianshipRouteSegmentsEnum.Start,
        GUARDIANSHIP_START_ROUTES_SEGMENTS.account,
      ),
    ]);
  }

  public gotoOutOfJurisdiction() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.GUARDIANSHIP,
        GuardianshipRouteSegmentsEnum.Start,
        GUARDIANSHIP_START_ROUTES_SEGMENTS.outOfJurisdiction,
      ),
    ]);
  }

  public goToConfirmation() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.GUARDIANSHIP,
        GuardianshipRouteSegmentsEnum.Start,
        GUARDIANSHIP_START_ROUTES_SEGMENTS.confirmation,
      ),
    ]);
  }

  public gotToWithoutCourtOrder() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.GUARDIANSHIP,
        GuardianshipRouteSegmentsEnum.Start,
        GUARDIANSHIP_START_ROUTES_SEGMENTS.withoutCourtOrder,
      ),
    ]);
  }
}
